export class RoomSelection {
  constructor (element, initRooms = [], hasMultiSelect, callbackRoomClick) {
    this.x1 = 0
    this.y1 = 0
    this.x2 = 0
    this.y2 = 0
    this.element = element
    this.isOpenActionModal = false
    this.selectedRoomIds = initRooms
    this.eventFirstClick = {}
    this.eventSecondClick = {}
    this.callbackRoomClick = callbackRoomClick

    this._keyPress = false
    this._begin = false

    this._startRectangle = this._startRectangle.bind(this)
    this._moveRectangle = this._moveRectangle.bind(this)
    this._endRectangle = this._endRectangle.bind(this)
    this._keyDownHandler = this._keyDownHandler.bind(this)
    this._keyUpHandler = this._keyUpHandler.bind(this)

    if (hasMultiSelect) {
      this._initEvents()
    }
  }

  _initEvents () {
    this.element.addEventListener('mousedown', this._startRectangle)
    document.addEventListener('mousemove', this._moveRectangle)
    document.addEventListener('mouseup', this._endRectangle)
    document.addEventListener('keydown', this._keyDownHandler)
    document.addEventListener('keyup', this._keyUpHandler)
  }

  _startRectangle (event) {
    const path = event.composedPath ? event.composedPath() : event.path
    if (path?.some(item => item.className?.includes('ui-chess-menu'))) {
      return
    }

    if (!this._keyPress) {
      this.selectedRoomIds = []
    }

    this._begin = true
    this.openActionModal(false, {})
    this.x1 = event.clientX
    this.y1 = event.clientY
    this.eventFirstClick = event
    this._createRectangle()
  }

  _createRectangle () {
    this._delRectangle()
    this.rectangle = document.createElement('div')
    this.rectangle.classList.add('select-rectangle')
    this.rectangle.style.top = `${this.y1}px`
    this.rectangle.style.left = `${this.x1}px`
    document.body.appendChild(this.rectangle)
    this.rectangle.addEventListener('mousemove', this._moveRectangle)
  }

  _moveRectangle (event) {
    if (!this._begin) return
    if (!this._hasCoord) return
    const x2 = event.clientX
    const y2 = event.clientY
    this.x2 = x2
    this.y2 = y2
    const PADDING = 5

    if (this.x1 < x2 && this.y1 > y2) {
      this.rectangle.style.top = `${y2}px`
    }

    if (this.x1 >= x2 && this.y1 >= y2) {
      this.rectangle.style.top = `${y2 + PADDING}px`
      this.rectangle.style.left = `${x2 + PADDING}px`
    }

    if (this.x1 > x2 && this.y1 < y2) {
      this.rectangle.style.left = `${x2}px`
    }

    this.rectangle.style.width = `${Math.abs(x2 - this.x1 - PADDING)}px`
    this.rectangle.style.height = `${Math.abs(y2 - this.y1 - PADDING)}px`
  }

  _checkInsertRooms () {
    let coords, cellX1, cellY1, cellX2, cellY2
    const cells = this.element.getElementsByClassName('ui-chess-item')
    for (let i = 0; i < cells.length; i++) {
      coords = cells[i].getBoundingClientRect()
      cellX1 = coords.x
      cellY1 = coords.y
      cellX2 = cellX1 + coords.width
      cellY2 = cellY1 + coords.height
      if (((this.x1 < cellX1 && this.y1 < cellY1) &&
        (this.x2 > cellX2 && this.y2 > cellY2)) ||

        ((this.x1 > cellX2 && this.y1 < cellY1) &&
        (this.x2 < cellX2 && this.y2 > cellY2)) ||

        ((this.x1 > cellX2 && this.y1 > cellY1) &&
          (this.x2 < cellX2 && this.y2 < cellY2)) ||

        ((this.x1 < cellX1 && this.y1 > cellY2) &&
          (this.x2 > cellX2 && this.y2 < cellY1))) {
        const id = +cells[i].id
        id && this.selectedRoomIds.push(id)
      }
    }
  }

  _initCoord () {
    this.x1 = 0
    this.y1 = 0
    this.x2 = 0
    this.y2 = 0
  }

  _delRectangle () {
    this.rectangle && document.body.removeChild(this.rectangle)
    this.rectangle = null
  }

  _hasCoord () {
    return this.x1 && this.y1 && this.x2 && this.y2
  }

  _endRectangle (event) {
    if (!this._begin) return
    this._begin = false
    this._delRectangle()

    if (!this._isClick()) {
      this._checkInsertRooms()
    } else {
      this._addOneRoom()
    }

    if (this.selectedRoomIds.length) {
      this.openActionModal(true, event)
    }

    this._initCoord()
  }

  _addOneRoom () {
    const id = this._getEventId()
    if (this._keyPress) {
      const i = this.selectedRoomIds.indexOf(id)
      if (i !== -1) {
        this.selectedRoomIds.splice(i, 1)
      } else {
        this.selectedRoomIds.push(id)
      }
    } else {
      if (id && this.callbackRoomClick) {
        this.callbackRoomClick?.(id)
        return
      }
      this.selectedRoomIds = id ? [id] : []
    }
  }

  _isClick () {
    if (this._getEventId()) return true
    return !(this.x2 && this.y2)
  }

  _getEventId (event) {
    const target = event || this.eventFirstClick.target
    return +(target.id || target.parentNode.id || target.parentNode.parentNode.id)
  }

  _keyDownHandler (event) {
    if (this._isKeyCtrl(event)) {
      this._keyPress = true
    }
  }

  _keyUpHandler (event) {
    if (this._isKeyCtrl(event)) {
      this._keyPress = false
    }
  }

  _isKeyCtrl (event) {
    return event.code === 'ControlLeft' || event.code === 'MetaLeft'
  }

  openActionModal (flag, event) {
    this.isOpenActionModal = flag
    this.eventSecondClick = event
  }

  destroy () {
    this.element.removeEventListener('mousedown', this._startRectangle)
    document.removeEventListener('mousemove', this._moveRectangle)
    document.removeEventListener('mouseup', this._endRectangle)
    document.removeEventListener('keydown', this._keyDownHandler)
    document.removeEventListener('keyup', this._keyUpHandler)
    this.openActionModal(false)
    this.selectedRoomIds = []
  }

  getIsBegin () {
    return this._begin
  }
}
